import AdsRequest from './request'
import Query from './const/query'
import Service from './const/service'

function createOperations (params) {
  const creates = (params instanceof Array) ? params : [params]
  return creates.map(c => ({ create: c }))
}

class Ads {
  init (token, customerId) {
    this.token = token
    this.customerId = customerId
  }

  async getCustomers () {
    const req = new AdsRequest(this.token, this.customerId)
    const { results } = await req.query(Query.SELECT_CUSTOMER_CLIENT)
    const clients = results.map(re => re.customerClient)
    const items = await Promise.all(
      clients.map(async (row) => {
        const req = new AdsRequest(this.token, row.clientCustomer)
        const { results } = await req.query(Query.SELECT_CUSTOMER)
        return results[0]
      })
    )
    return items
  }

  async getBudgets (customerId) {
    const req = new AdsRequest(this.token, customerId)
    const { results } = await req.query(Query.SELECT_BUDGET)
    return results || []
  }

  async addBudget (customerId, params) {
    const operations = createOperations(params)
    const req = new AdsRequest(this.token, customerId)
    const data = { operations: operations }
    const res = await req.post(Service.MUTATE_BUDGET, data)
    return res
  }

  async getCampaigns (customerId) {
    const req = new AdsRequest(this.token, customerId)
    const { results } = await req.query(Query.SELECT_CAMPAIGN)
    return results || []
  }

  async addCampaign (customerId, params) {
    const operations = createOperations(params)
    const req = new AdsRequest(this.token, customerId)
    const data = { operations: operations }
    const res = await req.post(Service.MUTATE_CAMPAIGNS, data)
    return res
  }

  async getAdGroups (customerId, campaignId = false) {
    const req = new AdsRequest(this.token, customerId)
    const query = (campaignId)
      ? Query.SELECT_AD_GROUP + ` AND campaign.id = ${campaignId}`
      : Query.SELECT_AD_GROUP
    const { results } = await req.query(query)
    return results || []
  }

  async addAdGroup (customerId, params) {
    const operations = createOperations(params)
    const req = new AdsRequest(this.token, customerId)
    const data = { operations: operations }
    const res = await req.post(Service.MUTATE_AD_GROUPS, data)
    return res
  }

  async getAdGroupAds (customerId, adGroupId = false) {
    const req = new AdsRequest(this.token, customerId)
    const query = (adGroupId)
      ? Query.SELECT_AD_GROUP_AD + ` AND ad_group.id = ${adGroupId}`
      : Query.SELECT_AD_GROUP_AD
    const { results } = await req.query(query)
    return results || []
  }

  async addAdGroupAd (customerId, params) {
    const operations = createOperations(params)
    const req = new AdsRequest(this.token, customerId)
    const data = { operations: operations }
    const res = await req.post(Service.MUTATE_AD_GROUP_ADS, data)
    return res
  }

  async getAdGroupKeywords (customerId, adGroupId = false) {
    const req = new AdsRequest(this.token, customerId)
    const query = (adGroupId)
      ? Query.SELECT_AD_GROUP_KEYWORD + ` AND ad_group.id = ${adGroupId}`
      : Query.SELECT_AD_GROUP_KEYWORD
    const { results } = await req.query(query)
    return results || []
  }

  async addAdGroupKeyword (customerId, params) {
    const operations = createOperations(params)
    const req = new AdsRequest(this.token, customerId)
    const data = { operations: operations }
    const res = await req.post(Service.MUTATE_AD_GROUP_CRITERIA, data)
    return res
  }
}

const instance = new Ads()
export default instance
export const setAdsToken = (token, customerId) => {
  instance.init(token, customerId)
}
